import styled from 'styled-components';
import { ArrowBack } from '@styled-icons/boxicons-regular/ArrowBack';

export const MyButton = styled.button`
  border: none;
  background: none;
  cursor: pointer;

  display: flex;
  align-items: center;
  color: ${({ theme }) => theme.colors.blue};
  font-weight: 700;

  &:hover {
    opacity: 0.75;
  }

  & > span {
    font-size: 0.875rem;
  }
`;

export const BackIcon = styled(ArrowBack)`
  width: 1.5rem;
  margin-right: 0.5rem;
`;
